// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1gtwH","right":"styles_right__2b0d7"};